import { useArtistAppearsOnInfo } from '@hooks/useArtistAppearsOn';
import { usePagination } from '@hooks/usePagination';
import { AppearsOn } from './AppearsOn';

interface AppearsOnContainerProps {
  artistName: string;
  artistUri: string;
}

export const AppearsOnContainer = ({
  artistName,
  artistUri,
}: AppearsOnContainerProps) => {
  const {
    limit,
    page,
    renderPagination: renderArtistAppearsOnPagination,
  } = usePagination();

  const {
    data: { appearsOnInfo },
    error,
    isValidating,
    isLoading,
  } = useArtistAppearsOnInfo(artistUri, page, limit);

  const isError = !!error && !isValidating;

  return (
    <AppearsOn
      albums={appearsOnInfo?.appearsOn || []}
      artistName={artistName}
      isLoading={isLoading || isValidating}
      isError={isError}
      paginationProps={
        appearsOnInfo?.appearsOnPaginationContext
          ? {
              appearsOnPaginationContext:
                appearsOnInfo?.appearsOnPaginationContext,
              renderArtistAppearsOnPagination,
            }
          : undefined
      }
    />
  );
};
